import { render, staticRenderFns } from "./AppTableRates.vue?vue&type=template&id=d29ec32c&"
import script from "./AppTableRates.vue?vue&type=script&lang=ts&"
export * from "./AppTableRates.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableRates.vue?vue&type=style&index=0&id=d29ec32c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports